/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
// import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import { ChartInfo } from '../../components/ChartInfo';
import { LocalStorageEnum } from '../../enums/LocalStorageEnum';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import FolderOpenOutlinedIcon from '@material-ui/icons/FolderOpenOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
            '&:hover': {
                '& .scroll': {
                    display: 'flex !important',
                    '& .Mui-disabled': {
                        '& .MuiSvgIcon-root': {
                            color: 'inherit !important',
                        },
                    },
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        footerDescription: {
            fontSize: '1rem',
            textAlign: 'center',
        },
        scrollUp: {
            display: 'none',
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            display: 'none',
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
    }),
);

enum DateRangeSelectionEnum {
    TODAY = 0,
    YESTERDAY,
    THIS_WEEK,
    LAST_WEEK,
    THIS_MONTH,
    LAST_MONTH,
    YEAR_TO_DATE,
}

interface ClosedMattersByFeeEarnerChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: DateRangeSelectionEnum;
}

interface ChartState {
    options: DateRangeSelectionEnum;
    groupedByData: string[];
    countData: number[];
    total: number;
}

export const ClosedMattersByFeeEarnerChart: React.FC<ClosedMattersByFeeEarnerChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0,
    })[1];

    const [state, setState] = useState<ChartState>({
        options: props.selectedOption === undefined ? DateRangeSelectionEnum.THIS_MONTH : props.selectedOption,
        total: 0,
        groupedByData: [],
        countData: [],
    });

    React.useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    // tslint:disable-next-line:no-any
    const closedMattersByFeeEarnerQuery = useQuery<ClosedMattersByFeeEarnerData>(CLOSED_MATTERS_BY_FEE_EARNER_DATA, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        if (
            !closedMattersByFeeEarnerQuery.loading &&
            !closedMattersByFeeEarnerQuery.error &&
            closedMattersByFeeEarnerQuery &&
            closedMattersByFeeEarnerQuery.data &&
            closedMattersByFeeEarnerQuery.data.statistics &&
            closedMattersByFeeEarnerQuery.data.statistics.matter &&
            closedMattersByFeeEarnerQuery.data.statistics.matter.closedMattersByFeeEarner
        ) {
            setState((prevState) => {
                let _total: number = 0;
                let groupedByData: string[] = [];
                let countData: number[] = [];

                var {
                    closedMattersByFeeEarnerToday,
                    closedMattersByFeeEarnerYesterday,
                    closedMattersByFeeEarnerThisWeek,
                    closedMattersByFeeEarnerLastWeek,
                    closedMattersByFeeEarnerThisMonth,
                    closedMattersByFeeEarnerLastMonth,
                    closedMattersByFeeEarnerYearToDate,
                } = closedMattersByFeeEarnerQuery.data!.statistics.matter.closedMattersByFeeEarner;

                if (state.options === DateRangeSelectionEnum.TODAY) {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerToday;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                } else if (state.options === DateRangeSelectionEnum.YESTERDAY) {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerYesterday;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                } else if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerThisWeek;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                } else if (state.options === DateRangeSelectionEnum.LAST_WEEK) {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerLastWeek;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                } else if (state.options === DateRangeSelectionEnum.THIS_MONTH) {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerThisMonth;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                } else if (state.options === DateRangeSelectionEnum.LAST_MONTH) {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerLastMonth;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                } else {
                    const { closedMattersByFeeEarnerGrouped, total } = closedMattersByFeeEarnerYearToDate;
                    groupedByData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.groupedBy);
                    countData = closedMattersByFeeEarnerGrouped.map((closedMatters: ClosedMattersByFeeEarnerGrouped) => closedMatters.count);
                    _total = total;
                }
                return {
                    ...prevState,
                    groupedByData,
                    countData,
                    total: _total,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [state.options, closedMattersByFeeEarnerQuery.loading, closedMattersByFeeEarnerQuery.error, closedMattersByFeeEarnerQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isClosedMattersByFeeEarnerChart`);
        }
    };

    const GetDateRangeSelectiondLabel = (dateRangeEnum: DateRangeSelectionEnum) => {
        switch (dateRangeEnum) {
            case DateRangeSelectionEnum.TODAY:
                return 'Today';
            case DateRangeSelectionEnum.YESTERDAY:
                return 'Yesterday';
            case DateRangeSelectionEnum.THIS_WEEK:
                return 'This Week';
            case DateRangeSelectionEnum.LAST_WEEK:
                return 'Last Week';
            case DateRangeSelectionEnum.THIS_MONTH:
                return 'This Month';
            case DateRangeSelectionEnum.LAST_MONTH:
                return 'Last Month';
            case DateRangeSelectionEnum.YEAR_TO_DATE:
                return 'Financial Year to Date';
            default:
                return '';
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            if (state.options === DateRangeSelectionEnum.TODAY) {
                searchCriterias.push({ property: 'ThisDay', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.YESTERDAY) {
                searchCriterias.push({ property: 'ThisDay', operator: 'entered', comparison: 'prev' });
            } else if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                searchCriterias.push({ property: 'ThisWeek', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.LAST_WEEK) {
                searchCriterias.push({ property: 'ThisWeek', operator: 'entered', comparison: 'prev' });
            } else if (state.options === DateRangeSelectionEnum.THIS_MONTH) {
                searchCriterias.push({ property: 'ThisMonth', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.LAST_MONTH) {
                searchCriterias.push({ property: 'ThisMonth', operator: 'entered', comparison: 'prev' });
            } else {
                searchCriterias.push({ property: 'YearToDate', operator: 'entered', comparison: 'curr' });
            }
            props.getSelectedItem(searchCriterias, true, `Closed Matters ${GetDateRangeSelectiondLabel(state.options)}`, DrillDownType.matterSummaryDrilldown, 'Duration');
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                options: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {
        const labels = state.groupedByData;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.countData;
        // up
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const onZoom = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // const onMaximize = () => {
    //     if (props.onMaximize) {
    //         props.onMaximize(state.options);
    //     }
    // };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload =
        (name: string, extension: string = 'jpg') =>
        // tslint:disable-next-line: no-any
        (image: any) => {
            const a = document.createElement('a');
            a.href = image;
            a.download = createFileName(extension, name);
            a.click();
        };

    // tslint:disable-next-line: no-any
    const onDownloadScreenshot = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload(`Hours Recorded`));
            // tslint:disable-next-line: align
        }, 500);
    };

    const chartControlComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {/* {!props.showAllRecords && props.onMaximize && (
                        <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                            <AspectRatioIcon />
                        </IconButton>
                    )} */}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    if (closedMattersByFeeEarnerQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.countData) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControlComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<FolderOpenOutlinedIcon />} title="Closed Matters" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.total} format={(amount) => `${Math.round(amount)}`} />
                </div>
                <div className={classes.title}>{GetDateRangeSelectiondLabel(state.options)}</div>
                <div className={classes.title}>By {localStorage.getItem(LocalStorageEnum.PersonActing) || `Person Acting`}</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton size="medium" onClick={onScollBar('up')} ref={scrollUpAndPrevRef}>
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton size="medium" onClick={onScollBar('down')} ref={scrollDownAndNextRef}>
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const item = state.groupedByData[_index];

                            const grouping = state.groupedByData[_index];

                            const searchCriterias = new Array<SearchCriteria>();

                            if (state.options === DateRangeSelectionEnum.TODAY) {
                                searchCriterias.push(
                                    { property: 'ThisDay', operator: 'entered', comparison: 'curr' },
                                    { property: 'PersonActing', operator: '', comparison: grouping },
                                );
                            } else if (state.options === DateRangeSelectionEnum.YESTERDAY) {
                                searchCriterias.push(
                                    { property: 'ThisDay', operator: 'entered', comparison: 'prev' },
                                    { property: 'PersonActing', operator: '', comparison: grouping },
                                );
                            } else if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                                searchCriterias.push(
                                    { property: 'ThisWeek', operator: 'entered', comparison: 'curr' },
                                    { property: 'PersonActing', operator: '', comparison: grouping },
                                );
                            } else if (state.options === DateRangeSelectionEnum.LAST_WEEK) {
                                searchCriterias.push(
                                    { property: 'ThisWeek', operator: 'entered', comparison: 'prev' },
                                    { property: 'PersonActing', operator: '', comparison: grouping },
                                );
                            } else if (state.options === DateRangeSelectionEnum.THIS_MONTH) {
                                searchCriterias.push(
                                    { property: 'ThisMonth', operator: 'entered', comparison: 'curr' },
                                    { property: 'PersonActing', operator: '', comparison: grouping },
                                );
                            } else {
                                searchCriterias.push(
                                    { property: 'YearToDate', operator: 'entered', comparison: 'curr' },
                                    { property: 'PersonActing', operator: '', comparison: grouping },
                                );
                            }
                            props.getSelectedItem(
                                searchCriterias,
                                true,
                                `Closed Matters for ${item} ${GetDateRangeSelectiondLabel(state.options)}`,
                                DrillDownType.matterSummary,
                                'Duration',
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.groupedByData),
                        datasets: [
                            {
                                label: 'Matters',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.countData,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(state.countData),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.countData),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                ticks: rvCategoryAxisStyle.ticks,
                                min: 0,
                                max: 9, // props.showAllRecords ? 19 : 9,
                            },
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false, // props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false, // props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        var tooltips = [`${dataset.label}: ${currentValue}`];
                                        return tooltips;
                                    },
                                    // // tslint:disable-next-line: no-any no-shadowed-variable
                                    // afterLabel: function (context: any) {
                                    //     const { dataIndex } = context;

                                    //     const feeAmount = state.countData[dataIndex];

                                    //     return [`Matters: ${state.symbol}${formatNumber(feeAmount, 2)}`];
                                    // },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.countData) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div">
                <RadioGroup name="last" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={DateRangeSelectionEnum.TODAY} control={<Radio color="primary" />} label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.TODAY)} />
                    <FormControlLabel
                        value={DateRangeSelectionEnum.YESTERDAY}
                        control={<Radio color="primary" />}
                        label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.YESTERDAY)}
                    />
                    <FormControlLabel
                        value={DateRangeSelectionEnum.THIS_WEEK}
                        control={<Radio color="primary" />}
                        label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.THIS_WEEK)}
                    />
                    <FormControlLabel
                        value={DateRangeSelectionEnum.LAST_WEEK}
                        control={<Radio color="primary" />}
                        label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_WEEK)}
                    />
                    <FormControlLabel
                        value={DateRangeSelectionEnum.THIS_MONTH}
                        control={<Radio color="primary" />}
                        label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.THIS_MONTH)}
                    />
                    <FormControlLabel
                        value={DateRangeSelectionEnum.LAST_MONTH}
                        control={<Radio color="primary" />}
                        label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_MONTH)}
                    />
                    <FormControlLabel
                        value={DateRangeSelectionEnum.YEAR_TO_DATE}
                        control={<Radio color="primary" />}
                        label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.YEAR_TO_DATE)}
                    />
                </RadioGroup>
            </FormControl>
            {/* <span className={classes.span}>{formatNumber(state.openEnquiryCount)} open enquiries have no Fee Estimate</span> */}
            {/* <span className={classes.span}>Drill down to timekeeper details</span>     
            <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
        </div>
    );
};

export interface ClosedMattersByFeeEarnerData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    closedMattersByFeeEarner: ClosedMattersByFeeEarner;
}

export interface ClosedMattersByFeeEarner {
    closedMattersByFeeEarnerToday: ClosedMattersByFeeEarnerLastMonthClass;
    closedMattersByFeeEarnerYesterday: ClosedMattersByFeeEarnerLastMonthClass;
    closedMattersByFeeEarnerThisWeek: ClosedMattersByFeeEarnerLastMonthClass;
    closedMattersByFeeEarnerLastWeek: ClosedMattersByFeeEarnerLastMonthClass;
    closedMattersByFeeEarnerThisMonth: ClosedMattersByFeeEarnerLastMonthClass;
    closedMattersByFeeEarnerLastMonth: ClosedMattersByFeeEarnerLastMonthClass;
    closedMattersByFeeEarnerYearToDate: ClosedMattersByFeeEarnerLastMonthClass;
}

export interface ClosedMattersByFeeEarnerLastMonthClass {
    closedMattersByFeeEarnerGrouped: ClosedMattersByFeeEarnerGrouped[];
    total: number;
}

export interface ClosedMattersByFeeEarnerGrouped {
    groupedBy: string;
    count: number;
}

const CLOSED_MATTERS_BY_FEE_EARNER_DATA = gql`
    fragment ClosedMattersByFeeEarnerByPeriodFragment on ClosedMattersByFeeEarnerByPeriod {
        closedMattersByFeeEarnerGrouped {
            groupedBy
            count
        }
        total
    }
    query closedMattetsByFeeEarnerData($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            matter {
                closedMattersByFeeEarner(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    closedMattersByFeeEarnerToday {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                    closedMattersByFeeEarnerYesterday {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                    closedMattersByFeeEarnerThisWeek {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                    closedMattersByFeeEarnerLastWeek {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                    closedMattersByFeeEarnerThisMonth {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                    closedMattersByFeeEarnerLastMonth {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                    closedMattersByFeeEarnerYearToDate {
                        ...ClosedMattersByFeeEarnerByPeriodFragment
                    }
                }
            }
        }
    }
`;
